import { j as g } from "./jsx-runtime-944c88e2.js";
import { R as _ } from "./Reveal-e2f427f6.js";
import * as n from "react";
import { p as d } from "./index-efd35e77.js";
import { v as G, c as y, p as V } from "./package-metadata-a152adb8.js";
import { M as O, N as H } from "./index.es-6889c727.js";
import { d as B } from "./dispatchEvent-96624a5c.js";
import { K as T } from "./keys-029ad48d.js";
import { u as L } from "./useRtl-f0f2cf5a.js";
import { I as M } from "./utils-85710523.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "react-dom";
import "./index-64063129.js";
var U = -1, X = 0, W = function(e, a, l) {
  var r = typeof e == "string" ? parseInt(e, void 0) : e;
  if (r !== NaN)
    return r !== void 0 ? r : a ? l ? void 0 : U : X;
}, C = globalThis && globalThis.__spreadArray || function(e, a, l) {
  if (l || arguments.length === 2)
    for (var r = 0, i = a.length, o; r < i; r++)
      (o || !(r in a)) && (o || (o = Array.prototype.slice.call(a, 0, r)), o[r] = a[r]);
  return e.concat(o || Array.prototype.slice.call(a));
};
function q(e) {
  var a = e.onFocus, l = e.onBlur, r = e.onSyncFocus, i = e.onSyncBlur, o = n.useRef(!1), s = n.useRef(0), f = n.useCallback(function(t) {
    clearTimeout(s.current), s.current = window.setTimeout(function() {
      return t();
    });
  }, [s]), m = n.useCallback(function() {
    for (var t = [], c = 0; c < arguments.length; c++)
      t[c] = arguments[c];
    clearTimeout(s.current), r && r.call(void 0, t[0]), !o.current && (o.current = !0, a && a.call.apply(a, C([void 0], t, !1)));
  }, [o, a, r]), v = n.useCallback(function() {
    for (var t = [], c = 0; c < arguments.length; c++)
      t[c] = arguments[c];
    i && i.call(void 0, t[0]), f(function() {
      o.current && l && (o.current = !1, l.call.apply(l, C([void 0], t, !1)));
    });
  }, [o, f, l, i]);
  return n.useEffect(function() {
    return function() {
      clearTimeout(s.current);
    };
  }, []), {
    onFocus: m,
    onBlur: v
  };
}
var k = n.forwardRef(function(e, a) {
  var l, r;
  G(V);
  var i = n.useRef(null), o = n.useState(!1), s = o[0], f = o[1], m = n.useCallback(function() {
    return { element: i.current };
  }, []);
  n.useImperativeHandle(a, m);
  var v = e.expanded, t = v === void 0 ? !1 : v, c = e.disabled, I = e.title, E = e.subtitle, p = e.onAction, b = e.expandIcon, x = e.collapseIcon, A = e.expandSVGIcon, R = e.collapseSVGIcon, S = n.useCallback(function(u) {
    B(p, u, m(), { expanded: t });
  }, [p, t]), w = n.useCallback(function(u) {
    (u.keyCode === T.enter || u.keyCode === T.space) && (u.preventDefault(), B(p, u, m(), { expanded: t }));
  }, [p, t]), D = n.useCallback(function() {
    e.disabled || f(!0);
  }, [e.disabled]), j = n.useCallback(function() {
    e.disabled || f(!1);
  }, [e.disabled]), N = q({ onFocus: D, onBlur: j }), K = N.onFocus, P = N.onBlur;
  return n.createElement(
    "div",
    { ref: i, className: y("k-expander", e.className, {
      "k-expanded": t,
      "k-focus": s && !c,
      "k-disabled": c
    }), onFocus: K, onBlur: P, style: e.style, id: e.id, dir: L(i, e.dir), onKeyDown: c ? void 0 : w },
    n.createElement(
      "div",
      { role: "button", "aria-controls": e.ariaControls, "aria-expanded": t, "aria-disabled": c, tabIndex: W(e.tabIndex, c), className: "k-expander-header", onClick: c ? void 0 : S },
      I !== void 0 ? n.createElement("div", { className: "k-expander-title" }, I) : void 0,
      n.createElement("span", { className: "k-spacer" }),
      E !== void 0 ? n.createElement("div", { className: "k-expander-sub-title" }, E) : void 0,
      n.createElement(
        "span",
        { className: "k-expander-indicator" },
        n.createElement(M, { name: t ? x ? void 0 : "chevron-up" : b ? void 0 : "chevron-down", icon: t ? R ? void 0 : H : A ? void 0 : O, className: y(t ? (l = {}, l[String(x)] = !!x, l) : (r = {}, r[String(b)] = !!b, r)) })
      )
    ),
    e.children
  );
});
k.propTypes = {
  children: d.node,
  className: d.string,
  style: d.object,
  dir: d.string,
  id: d.string,
  tabIndex: d.number,
  title: d.node,
  subtitle: d.node,
  expandIcon: d.string,
  collapseIcon: d.string,
  expanded: d.bool,
  disabled: d.bool,
  onAction: d.func
};
k.displayName = "KendoReactExpansionPanel";
var h = globalThis && globalThis.__assign || function() {
  return h = Object.assign || function(e) {
    for (var a, l = 1, r = arguments.length; l < r; l++) {
      a = arguments[l];
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
    }
    return e;
  }, h.apply(this, arguments);
}, F = n.forwardRef(function(e, a) {
  return n.createElement(
    "div",
    h({ ref: a }, e, { className: y("k-expander-content-wrapper", e.className) }),
    n.createElement("div", { className: "k-expander-content" }, e.children)
  );
});
F.displayName = "KendoReactExpansionPanelContent";
const oe = (e) => /* @__PURE__ */ g.jsx(k, { ...e, children: /* @__PURE__ */ g.jsx(_, { children: e.expanded && /* @__PURE__ */ g.jsx(F, { children: e.children }) }) });
export {
  oe as Accordion
};
